import React from "react";
import { withStyles } from "@material-ui/styles";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { Link } from "react-router-dom";
import { get, filter } from "lodash";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import CloseIcon from "../Common/CloseIcon";
import EventsContainer from "./EventsContainer";

import { getLov } from "../../utils/lov";
import { getLovValue } from "../../utils/profile";

import colors from "../../assets/style/colors";

const styles = {
  dialogRoot: {
    //zIndex: "8000 !important",
  },
  dialogPaper: {
    minWidth: "calc(100vw - 100px)",
    maxWidth: "calc(100vw - 100px)",
  },
  link: {
    cursor: "pointer",
    color: colors.primary,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  closeIcon: {
    paddingRight: "12px",
    display: "flex",
    justifyContent: "flex-end",
  },
  field: {
    marginLeft: "40px",
    "& span": {
      padding: "0px 4px",
    },
  },
};

const EventsDialog = (props) => {
  const { classes, eventGroupId, events, language } = props;
  const [open, setOpen] = React.useState(false);
  const [lov, setLov] = React.useState();

  React.useEffect(() => {
    const fetchLov = async () => {
      setLov({
        riskLevel: await getLov("riskLevel"),
      });
    };
    fetchLov();
  }, []);

  const eventGroup = get(
    filter(
      get(events, ["eventGroups"]),
      (eg) => get(eg, ["id"]) === eventGroupId
    ),
    [0]
  );

  return (
    <>
      <span
        onClick={() => !props.disabled && setOpen(true)}
        className={props.disabled ? "text-54" : classes.link}
      >
        {props.text || `${I18n.get("profiles_viewEventGroup")} ${eventGroupId}`}
      </span>
      <Dialog
        open={open}
        classes={{ root: classes.dialogRoot, paper: classes.dialogPaper }}
      >
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ height: "100%" }}
        >
          <Grid item style={{ padding: "12px 0px" }}>
            <Grid container alignItems="center">
              <Grid item style={{ padding: "0px 24px" }}>
                <Link
                  to={`/events/eventGroups/${eventGroupId}`}
                  className={classes.link}
                >
                  {I18n.get("events_goToEventsPage")}
                </Link>
              </Grid>
              <Grid item className={classes.field}>
                <span className="text-87 bold-500">
                  {I18n.get("profiles_eventGroupId")}:
                </span>
                <span className="text-54">{get(eventGroup, ["id"])}</span>
              </Grid>
              <Grid item className={classes.field}>
                <span className="text-87 bold-500">
                  {I18n.get("profiles_riskLevel")}:
                </span>
                <span className="text-54">
                  {get(eventGroup, ["risk_level"]) !== undefined &&
                    get(lov, ["riskLevel"]) &&
                    getLovValue(
                      "riskLevel",
                      get(eventGroup, ["risk_level"]),
                      lov,
                      language
                    )}
                </span>
              </Grid>
              {/* <Grid item className={classes.field}>
                <span className="text-87 bold-500">
                  {I18n.get("dashboard_company")}:
                </span>
                <span className="text-54"></span>
              </Grid> */}
              <Grid item className={classes.field}>
                <span className="text-87 bold-500">
                  {I18n.get("common_site")}:
                </span>
                <span className="text-54">
                  {get(eventGroup, ["events", 0, "zone", "site", "name"])}
                </span>
              </Grid>
              <Grid item className={classes.field}>
                <span className="text-87 bold-500">
                  {I18n.get("common_zone")}:
                </span>
                <span className="text-54">
                  {get(eventGroup, ["events", 0, "zone", "site", "name"])}
                </span>
              </Grid>
              <Grid item xs />
              <Grid item xs={2} className={classes.closeIcon}>
                <CloseIcon closeFunction={() => setOpen(false)} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <EventsContainer dialog={true} eventGroupId={eventGroupId} />
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    events: state.events,
    language: state.user.language,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(EventsDialog));
